import React, {useState, useRef, useEffect} from 'react';
import sad from "../../../assets/images/icons/atc/sad.svg"
import happy from "../../../assets/images/icons/atc/happy.svg"
import neutral from "../../../assets/images/icons/atc/neutral.svg"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const BarChartATC = ({
  title,
  data = [],
  xAxisDataKey = 'name',
  xAxisLabel = '',
  chartTitle = '',
  height = 250,
  tooltipLabelFormatter = label => label,
//  barDataKey = "value",
 // yAxisLabel = '',
 // barColor = "#184A7D",

 // barLabelFormatter = value => value,
  showLegend = false,
  bars = [
    {
      dataKey: 'emptyATC',  
      name: 'ATC Vacías',   
      fill: '#58B6E5',      
      label: false
    },
    {
      dataKey: 'rejectedATC',  
      name: 'ATC Rechazadas',
      fill: '#BD002A',
      label: false
    }
  ],
  barsize,
  barGap = 8,
  barCategoryGap = '20%',
  loading = false,
  atcSummary = null
}) => {
  const [visibleBars, setVisibleBars] = useState({
    'emptyATC': true,
    'rejectedATC': true
  });

  const [showEmptyATCTooltip, setShowEmptyATCTooltip] = useState(false);
  const [showRejectedATCTooltip, setShowRejectedATCTooltip] = useState(false);

  const [clickedTooltip, setClickedTooltip] = useState(null);

  const emptyTooltipRef = useRef(null);
  const rejectedTooltipRef = useRef(null);
  const emptyIconRef = useRef(null);
  const rejectedIconRef = useRef(null);

  const isMobile = () => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 1024; 
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (clickedTooltip) {
        const isClickInsideTooltip = 
          (emptyTooltipRef.current && emptyTooltipRef.current.contains(event.target)) ||
          (rejectedTooltipRef.current && rejectedTooltipRef.current.contains(event.target));
        
        const isClickOnIcon = 
          (emptyIconRef.current && emptyIconRef.current.contains(event.target)) ||
          (rejectedIconRef.current && rejectedIconRef.current.contains(event.target));
        
        if (!isClickInsideTooltip && !isClickOnIcon) {
          setClickedTooltip(null);
        }
      }
    };

    if (clickedTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [clickedTooltip]);

  useEffect(() => {
    const handleResize = () => {
      if (!isMobile() && clickedTooltip) {
        setClickedTooltip(null);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [clickedTooltip]);
  
  const toggleBarVisibility = (dataKey) => {

    if (visibleBars[dataKey]) {
      setVisibleBars({
        [dataKey]: false,
        [dataKey === 'emptyATC' ? 'rejectedATC' : 'emptyATC']: true
      });
    } else {
      setVisibleBars({
        [dataKey]: true,
        [dataKey === 'emptyATC' ? 'rejectedATC' : 'emptyATC']: false
      });
    }
  };

  const showBothBars = () => {
    setVisibleBars({
      'emptyATC': true,
      'rejectedATC': true
    });
  };

  const bothVisible = visibleBars['emptyATC'] && visibleBars['rejectedATC'];

  const filteredBars = bars.filter(bar => visibleBars[bar.dataKey]);

  const renderCustomizedAxisTick = ({ x, y, payload }) => {
    const idx = data.findIndex(item => item[xAxisDataKey] === payload.value);
    const fillColor = idx === 0 ? 'red' : '#007696';
    return (
      <text
        x={x}
        y={y + 15}
        textAnchor="middle"
        fill={fillColor}
        fontSize={11}
        fontFamily="ITC-book, sans-serif"
      >
        {payload.value}
      </text>
    );
  };

  const handleIconClick = (tooltipType) => {
    if (isMobile()) {

      setClickedTooltip(clickedTooltip === tooltipType ? null : tooltipType);
    }
  };
  
  
  if (loading) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <div className="w-6 h-6 border-2 border-gray-300 rounded-full animate-spin border-t-transparent" />
        <p className="ml-3 text-gray-500">Cargando...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <p className="text-gray-500">No hay datos disponibles</p>
      </div>
    );
  }



  return (
    <div className="relative w-full">
      {chartTitle &&
        <h3 className="mb-2 text-lg font-semibold">
          {chartTitle}
        </h3>
      }
      <div className="w-full h-full p-4 px-6 bg-white overflow-x-auto shadow-md rounded-[10px]">
        <div className='flex flex-col justify-between w-full sm:flex-row'>
            <h1 className="pb-4 text-base text-blue font-itcbold">{title}</h1>
            <div className="border border-blue rounded-lg  w-[336px] relative overflow-visible">
              <table className="h-[60px] border-collapse">
                  <tbody>
                    <tr className="relative border-b border-blue">
                      <td className="w-[151px] h-[30px] p-1 px-2 border-r border-blue">
                        <span className="text-[#58B6E5] text-xs sm:text-sm font-itcbold">ATC Vacías</span>
                      </td>
                      <td className="w-[121px] h-[30px] p-1 text-center border-r border-blue">
                        <span className="text-sm font-itcbold">
                          { atcSummary?.currentStatus?.emptyATC?.count || 0}
                        </span>
                      </td>
                      <td 
                        onMouseEnter={() => !isMobile() && setShowEmptyATCTooltip(true)}
                        onMouseLeave={() => !isMobile() && setShowEmptyATCTooltip(false)}
                        onClick={() => handleIconClick('emptyATC')}
                        className="w-[66px] h-[30px] p-1 text-center relative">
                        <div className="flex justify-center">
                          <div 
                            ref={emptyIconRef}
                            className="relative"
                          >
                            {atcSummary?.currentStatus?.emptyATC?.status === 'happy' && (
                              <img src={happy} alt="Feliz"/>
                            )}
                            {atcSummary?.currentStatus?.emptyATC?.status === 'sad' && (
                              <img src={sad} alt="Triste" className='animate-zoom-pulse'/>
                            )}
                            {atcSummary?.currentStatus?.emptyATC?.status === 'neutral' && (
                              <img src={neutral} alt="Neutral" className='w-5 h-5'/>
                            )}
                          </div>
                          {(showEmptyATCTooltip || clickedTooltip === 'emptyATC') && 
                            atcSummary?.currentStatus?.emptyATC?.message && (
                            <div 
                              ref={emptyTooltipRef}
                              className="absolute p-2 shadow-[0px_4px_5.2px_2px_rgba(0,0,0,0.25)] bg-white rounded-lg w-[250px] sm:w-[303px] right-[0%] z-30 -bottom-8  ">
                              <div className="text-xs font-itcbold text-blue">
                                <div className="absolute w-0 h-0 transform border-b-4 border-l-4 border-r-4 right-[9%]  bottom-full border-l-transparent border-r-transparent border-b-white"></div>
                                {atcSummary.currentStatus.emptyATC.message}
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="w-[151px] h-[30px] px-2 p-1 border-r border-blue">
                        <span className="text-[#BD002A] font-itcbold text-xs sm:text-sm">ATC Rechazadas</span>
                      </td>
                      <td className="w-[121px] h-[30px]  p-1 text-center border-r border-blue">
                        <span className="text-sm font-itcbold">
                          {atcSummary?.currentStatus?.rejectedATC?.count || 0}
                        </span>
                      </td>
                      <td
                        onMouseEnter={() => !isMobile() && setShowRejectedATCTooltip(true)}
                        onMouseLeave={() => !isMobile() && setShowRejectedATCTooltip(false)}
                        onClick={() => handleIconClick('rejectedATC')}
                        className="w-[66px] h-[30px]  p-1 text-center relative">
                        <div className="flex justify-center">                   
                          <div 
                              ref={rejectedIconRef}
                              className="relative"

                            >
                              {atcSummary?.currentStatus?.rejectedATC?.status === 'happy' && (
                                <img src={happy} alt="Happy"/>
                              )}

                              {atcSummary?.currentStatus?.rejectedATC?.status === 'sad' && (
                                <img src={sad} alt="Triste" className='animate-zoom-pulse'/>
                              )}

                              {atcSummary?.currentStatus?.rejectedATC?.status === 'neutral' && (
                                <img src={neutral} alt="Neutral" className='w-5 h-5'/>
                              )}
                          </div>
                          {(showRejectedATCTooltip || clickedTooltip === 'rejectedATC') && 
                            atcSummary?.currentStatus?.rejectedATC?.message && (
                            <div
                              ref={rejectedTooltipRef}
                              className="absolute p-2 shadow-[0px_4px_5.2px_2px_rgba(0,0,0,0.25)] bg-white rounded-lg   w-[250px] sm:w-[303px] right-[0%] z-30 -bottom-8">
                              <div className="text-xs font-itcbold text-blue">
                                <div className="absolute w-0 h-0 transform border-b-4 border-l-4 border-r-4 right-[9%] bottom-full border-l-transparent border-r-transparent border-b-white"></div>
                                  {atcSummary.currentStatus.rejectedATC.message}
                              </div>
                            </div>
                          )}    
                        </div>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
        </div>


        {/* Versión móvil con scroll horizontal */}
        <div className="w-full overflow-x-auto lg:hidden">
          <div style={{
            width: `${Math.max(data.length * 80, 300)}px`,
            height: `${height}px`
          }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 20, right: 20, left: -30, bottom: 5 }}
                layout="horizontal"
                barSize={barsize}
                barGap={barGap}
                barCategoryGap={barCategoryGap}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E7E7" />
                <YAxis 
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: '#737B8B', fontFamily: "ITC-book, sans-serif" }}
                />
                <XAxis
                  dataKey={xAxisDataKey}
                  label={{ value: xAxisLabel, position: 'bottom', offset: 30 }}
                  /* tick={{
                    fontSize: 11,
                    fill: '#007696',
                    fontFamily: "ITC-medium, sans-serif",
                  }} */
                  tick={renderCustomizedAxisTick}
                  interval={0}
                  height={35}
                  tickLine={false}
                  tickMargin={3}
                  axisLine={{ stroke: '#E2E7E7' }}
                />
                <Tooltip labelFormatter={tooltipLabelFormatter} />

                {filteredBars.map(({ dataKey, name, fill, label }, i) => (
                  <Bar
                    key={i}
                    dataKey={dataKey}
                    name={name}
                    fill={fill}
                    radius={[4, 4, 0, 0]}
                  />
                ))}
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>


        {/* Versión desktop */}
        <div className="hidden lg:block" style={{ height: `${height}px` }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 20, right: 10, left: -30, bottom: 5 }}
              layout="horizontal"
              barSize={barsize}
              barGap={barGap}
              barCategoryGap={barCategoryGap}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E7E7" />
              <YAxis 
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: '#737B8B', fontFamily: "ITC-book, sans-serif" }}
              />
              <XAxis
                dataKey={xAxisDataKey}
                label={{ value: xAxisLabel, position: 'bottom', offset: 30 }}
                /* tick={{
                  fontSize: 11,
                  fill: '#007696',
                  fontFamily: "ITC-medium, sans-serif",
                }} */
                tick={renderCustomizedAxisTick}
                interval={0}
                height={35}
                tickLine={false}
                tickMargin={3}
                axisLine={{ stroke: '#E2E7E7' }}
              />
              <Tooltip labelFormatter={tooltipLabelFormatter} />

              {filteredBars.map(({ dataKey, name, fill, label }, i) => (
                <Bar
                  key={i}
                  dataKey={dataKey}
                  name={name}
                  fill={fill}
                  radius={[4, 4, 0, 0]}
                  label={false}
                />
              ))}


            </BarChart>

          </ResponsiveContainer>
        </div>

        <div className="flex flex-col items-center justify-start gap-3 py-3 pl-7 sm:flex-row">
          {showLegend && (
            <div className="flex flex-col gap-6 lg:flex-row">
              {bars.map((bar, i) => {
                const isVisible = visibleBars[bar.dataKey];
                
                return (
                  <div 
                    key={i} 
                    className="flex items-center justify-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (bothVisible) {
                        toggleBarVisibility(bar.dataKey);
                      } else {
                        if (isVisible) {
                          toggleBarVisibility(bar.dataKey);
                        } else {
                          showBothBars();
                        }
                      }
                    }}
                  >
                    <div
                      className="w-[9px] h-[9px] mr-2 transition-all duration-200 rounded-full"
                      style={{ 
                        backgroundColor: isVisible ? bar.fill : '#D9D9D9',
                      }}
                    />
                    <span
                      className={`text-sm font-itcbook transition-all duration-200 hover:opacity-80`}
                      style={{ 
                        color: isVisible ? bar.fill : '#737B8B'
                      }}
                    >
                      {bar.name}
                    </span>
                  </div>
                );
              })}
              
            </div>
          )}
        </div>
        
      </div>

      {clickedTooltip && (
        <div 
          className="fixed inset-0 z-30"
          onClick={() => setClickedTooltip(null)}
          style={{ pointerEvents: 'auto' }}
        />
      )}
    </div>
  );
};

export default BarChartATC;